<template>
  <div class="market-bind-supply">
    <el-dialog
      width="640px"
      align="center"
      title="批量改「市场与与子市场」"
      :visible="visible"
      :before-close="closeBox"
    >
      <el-form :model="form">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商家id（一行一个，最多1000个）" required>
              <el-input
                v-model="form.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="选择城市" align="left" required>
              <el-select
                v-model="form.city"
                placeholder="请选择"
                filterable
                @change="getFirstMarketList"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择市场" align="left" required>
              <el-select
                v-model="form.first_id"
                placeholder="请选择"
                filterable
                @change="getSubMarketList"
              >
                <el-option
                  v-for="item in firstMarketList"
                  :key="item.market_id"
                  :value="item.market_id"
                  :label="item.market_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择子市场" align="left" required>
              <el-select
                v-model="form.market_id"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in subMarketList"
                  :key="item.market_id"
                  :value="item.market_id"
                  :label="item.market_name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBox">取 消</el-button>
        <el-button size="small" type="success" @click="submitData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
export default {
  name: 'MarketBindSupply',
  props: {
    supplyIds: {
      type: Array,
      default: () => [],
    },
    visibleType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: true,
      form: { city: '', first_id: '', market_id: '', supply_ids: "" },
      firstMarketList: [],
      cityList: [],
      subMarketList: []
    };
  },
  mounted() {
    this.fetchCity()
  },
  methods: {
    //城市数据
    fetchCity(){
      this.$http
        .post("/erp/Common/getCityList", {})
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.cityList = result.data.data.map(e =>({ ...e, value: e.key }));
        })
        .catch(() => {});
    },
    // 一级市场
    getFirstMarketList(id) {
      this.$http
        .post("/erp/Common/getFirstMarketList", { city: id })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.form.first_id = ""
          this.form.market_id = ""
          this.firstMarketList = result.data.data;
        })
        .catch(() => {});
    },
    // 二级市场
    getSubMarketList(id) {
      this.$http
        .post("/erp/Common/getSubMarketList", { parent_id: id })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.form.market_id = ""
          this.subMarketList = result.data.data;
        })
        .catch(() => {});
    },
    submitData() {
      const { city, first_id, market_id, supply_ids: supplyIds } = this.form;

      // 校验是否有商家id
      if (supplyIds === "") {
        this.$message({
          showClose: true,
          message: "请输入商家ids~",
          type: "error",
        });
        return;
      }
      if (!city) {
        this.$message({
          showClose: true,
          message: "请选择城市~",
          type: "error",
        });
        return;
      }
      if (!first_id) {
        this.$message({
          showClose: true,
          message: "请选择市场~",
          type: "error",
        });
        return;
      }
      if (!market_id) {
        this.$message({
          showClose: true,
          message: "请选择子市场~",
          type: "error",
        });
        return;
      }
      this.form.supply_ids = this.supplyIds;
      this.$http
        .post("/erp/Supply/batchUpdateMarket", {
          city,
          market_id,
          supply_ids: supplyIds.trim().split("\n"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            if (result.data.data && result.data.data.file) {
              window.open(apiBaseURL + result.data.data.file);
            }
            return;
          }
          this.$message.success("修改成功");
          this.closeBox();
        })
        .catch(() => {});
    },
    closeBox() {
      this.$emit("onCloseDialog", { visible: this.visibleType });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/supply/components/MarketBindSupply.vue